import { useI18n } from "../../lib/i18n/i18n_provider";
import { useIsWework } from "./use_is_wework";

export function useWeWorkExternalContactUrl(): string | undefined {
  const isWeWork = useIsWework();
  const { locale } = useI18n();

  if (!isWeWork) return undefined;

  return locale.baseLanguageTag === "he"
    ? "https://www.wework.co.il/contact"
    : "https://www.wework.co.il/en/contact";
}
